import React, {Dispatch, ReactNode, SetStateAction} from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './Checkbox.module.scss';

export interface CheckboxProps {
    id?: string | number,
    name?: string,
    onChange?: React.ChangeEventHandler<HTMLInputElement>,
    onBlur?: React.ChangeEventHandler<HTMLInputElement>,
    required?: boolean,
    checked?: boolean,
    defaultChecked?: boolean,
    children?: ReactNode,
    value?: string | number,
    state?: string | boolean | any[],
    setState?: Dispatch<SetStateAction<string | boolean | any[]>>,
    disabled?: boolean,
    indeterminate?: boolean,
    error?: boolean | string;
    textStyle?: string;
    className?: string
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>((props, ref,
) => {
    const {
        id,
        name,
        onChange,
        onBlur,
        required,
        checked: propsChecked,
        defaultChecked,
        children,
        value,
        state,
        setState,
        disabled,
        indeterminate,
        error,
        textStyle,
        className,
        ...rest
    } = props;

    const checked = state !== undefined ? !!state : propsChecked;

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        onChange?.(e);
        setState?.(e.target.checked);
    };

    React.useEffect(() => {
        if (!ref) return;
        const node = typeof ref === 'function' ? null : ref?.current;
        if (node) node.indeterminate = !!indeterminate;
    }, [indeterminate, ref]);

    return (
        <div className={cn(styles.container, className)}>
            <label className={cn(
                styles.label,
                isTranslate() && styles.enLabel,
                error && styles.error,
            )}>
                <input
                    type="checkbox"
                    ref={ref}
                    id={String(id ?? name)}
                    name={name}
                    className={cn(
                        styles.input,
                        isTranslate() && styles.enInput,
                    )}
                    onChange={handleChange}
                    onBlur={onBlur}
                    required={required}
                    checked={checked}
                    value={value}
                    disabled={disabled}
                    defaultChecked={defaultChecked}
                    {...rest}
                />
                <span className={styles.custom} />
                <span className={cn(
                    styles.text,
                    textStyle,
                )}>
                    {children}
                </span>
            </label>
        </div>
    );
});

Checkbox.displayName = 'Checkbox';

export default React.memo(Checkbox);